$(document).ready(function () {
    function getTotalElement() {
        return $(".totals__total-value");
    }

    function getPriceFromText(text) {
        return parseFloat(text.replace(/[^0-9.]/g, '')) || 0;
    }

    function formatPrice(value) {
        return `$${value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} USD`;
    }

    function getMaintenancePrice(productPrice) {
        if (productPrice < 500) return 49;
        if (productPrice >= 500 && productPrice < 750) return 79;
        if (productPrice >= 750 && productPrice < 1500) return 95;
        if (productPrice >= 1500 && productPrice < 1800) return 149;
        if (productPrice >= 1800) return 0;
        return 0;
    }

    function updateTotalFromCart() {
        fetch("/cart.js")
            .then(response => response.json())
            .then(cart => {
                let totalPrice = cart.total_price / 100;
                console.log("Updated Total from Cart:", totalPrice);
                getTotalElement().text(formatPrice(totalPrice));
            })
            .catch(error => console.error("Error fetching cart total:", error));
    }

    function removeMaintenancePlan(event) {
        event.preventDefault();

        var maintenanceDiv = $(this).closest(".maintenance-item");
        var productTitle = maintenanceDiv.data("product-title");

        console.log("Fetching cart to find Maintenance Plan for:", productTitle);

        fetch("/cart.js")
            .then(response => response.json())
            .then(cart => {
                var maintenanceItem = cart.items.find(item =>
                    item.properties && item.properties["Linked Product"] === productTitle
                );

                if (!maintenanceItem) {
                    console.warn("Maintenance plan not found in cart for:", productTitle);
                    return;
                }

                console.log("Removing Maintenance Plan for:", productTitle, " | Item Key:", maintenanceItem.key);

                fetch("/cart/update.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ updates: { [maintenanceItem.key]: 0 } })
                })
                .then(response => response.json())
                .then(data => {
                    console.log("Maintenance Plan Removed from Cart:", data);

                    var productPrice = getPriceFromText(maintenanceDiv.closest(".cart-item").find(".cart-item__price-wrapper .price").text());
                    var maintenancePrice = getMaintenancePrice(productPrice);

                    maintenanceDiv.replaceWith(`
                        <div class="cart-flex-maintenance">
                            <label class="checkbox-container">
                                <input type="checkbox" class="add-maintenance" data-product-title="${productTitle}" data-product-price="${productPrice}">
                                <span class="checkmark"></span>
                                <span class="label-text">Add Maintenance Plan ($${maintenancePrice})</span>
                            </label>
                        </div>
                    `);

                    updateTotalFromCart();
                })
                .catch(error => console.error("Error removing maintenance plan:", error));
            });
    }

    $(document).on("change", ".add-maintenance", function () {
        var checkbox = $(this);
        var productPrice = getPriceFromText(checkbox.closest(".cart-item").find(".cart-item__price-wrapper .price").text());
        var maintenancePrice = getMaintenancePrice(productPrice);

        console.log("Checkbox Changed - Product Price:", productPrice, " | Maintenance Plan Price:", maintenancePrice);

        if (checkbox.prop("checked")) {
            var totalElement = getTotalElement();
            var currentTotal = getPriceFromText(totalElement.text());
            var newTotal = currentTotal + maintenancePrice;
            totalElement.text(formatPrice(newTotal));
            console.log("Updated Total After Checkbox Click:", newTotal);
        } else {
            var totalElement = getTotalElement();
            var currentTotal = getPriceFromText(totalElement.text());
            var newTotal = currentTotal - maintenancePrice;
            totalElement.text(formatPrice(newTotal));
            console.log("Updated Total After Checkbox Click:", newTotal);
        }
    });

    $(document).on("click", ".remove-maintenance", function (event) {
        removeMaintenancePlan.call(this, event);
    });
});

document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener("click", function (event) {
        var checkoutButton = event.target.closest("#CartDrawer-Checkout");
        if (!checkoutButton) return;

        // COUNTRY CHECK: only add maintenance plan for US orders
        var country = (window.shopCountry || (window.Shopify && window.Shopify.country) || '').toUpperCase().trim();
        if (country !== '' && country !== 'US') {
            window.location.href = '/checkout';
            return;
        }

        event.preventDefault();

        var updates = {};
        var itemsToAdd = [];
        var cartItems = [];

        fetch("/cart.js")
            .then(response => response.json())
            .then(data => {
                cartItems = data.items;

                document.querySelectorAll(".cart-item").forEach(function (cartItem) {
                    var priceElement = cartItem.querySelector(".cart-item__price-wrapper .price");
                    var productTitle = cartItem.querySelector(".cart-item__name").innerText.trim();

                    var optionElements = cartItem.querySelectorAll(".product-option dd");
                    var variantTitle = Array.from(optionElements).map(el => el.innerText.trim()).join(" / ");

                    var checkbox = cartItem.querySelector(".cart-flex-maintenance input[type='checkbox']");
                    var maintenanceCost = priceElement ? getPriceFromText(priceElement.innerText) : 0;
                    var maintenanceVariantId = getMaintenanceVariantId(maintenanceCost);
                    var linkedProductTitle = `${productTitle} ${variantTitle}`;
                    var maintenancePlanExists = false;

                    cartItems.forEach(cartItem => {
                        if (
                            cartItem.properties &&
                            cartItem.properties["Linked Product"] === linkedProductTitle
                        ) {
                            maintenancePlanExists = true;
                            if (!checkbox || !checkbox.checked) {
                                updates[cartItem.id] = 0;
                            }
                        }
                    });

                    if (checkbox && checkbox.checked) {
                        if (!maintenancePlanExists) {
                            itemsToAdd.push({
                                id: maintenanceVariantId,
                                quantity: 1,
                                properties: {
                                    "Linked Product": linkedProductTitle
                                }
                            });
                        }
                    }
                });

                return fetch("/cart/update.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ updates: updates })
                });
            })
            .then(() => {
                if (itemsToAdd.length > 0) {
                    return fetch("/cart/add.js", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ items: itemsToAdd })
                    });
                }
            })
            .then(() => {
                window.location.href = '/checkout';
            })
            .catch(error => console.error("Error updating cart:", error));
    });

    function getPriceFromText(text) {
        return parseFloat(text.replace(/[^0-9.]/g, '')) || 0;
    }

    function getMaintenanceVariantId(cost) {
        if (cost <= 500) return "46447318892803";
        if (cost > 500 && cost <= 750) return "46447318925571";
        if (cost > 750 && cost <= 1500) return "46447318958339";
        if (cost > 1500 && cost < 1799) return "46447318991107";
        return "46447319023875";
    }
});